// extracted by mini-css-extract-plugin
module.exports = {"main-container":"ResultInformation_main-container__KKIRY","icon":"ResultInformation_icon__LRA0X","title":"ResultInformation_title__ZHiV3","desc":"ResultInformation_desc__y6KPx"};